import root from './_root.js';

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

export default coreJsData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_coreJsData.js
// module id = ./node_modules/lodash-es/_coreJsData.js
// module chunks = 0